import { ESTADO_CONFIGURACION_ANTIFRAUDE } from "api/Types/EstadoConfiguracionAntifraude"
import { useGetUsuarioByCurrentUser } from "api/Usuario.hook"
import { LeyAntiFraudeFormModal } from "feature-based/features/verifactu/organisms"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { VerifactuActive } from "./Verifactu/VerifactuActive"
import { VerifactuExento } from "./Verifactu/VerifactuExento"
import { VerifactuPending } from "./Verifactu/VerifactuPending"

import "feature-based/common/styles/reset-erp.css"

export interface VerifactuFormProps {
  verifactu: boolean
  exento: boolean
  motivo?: string | null
}

export const Verifactu = (): React.JSX.Element => {
  const { t } = useTranslation()
  const {
    usuario: { empresaActiva },
    usuarioInvalidation,
  } = useGetUsuarioByCurrentUser()

  const configuracionAntifraude =
    empresaActiva?.configuracion?.configuracionAntifraude

  const [showModal, setShowModal] = useState<boolean>(false)
  const { reset } = useForm<VerifactuFormProps>({
    defaultValues: {
      verifactu:
        configuracionAntifraude?.estado.id ===
        ESTADO_CONFIGURACION_ANTIFRAUDE.VERIFACTU,
      exento:
        configuracionAntifraude?.estado.id ===
        ESTADO_CONFIGURACION_ANTIFRAUDE.EXENTO,
      motivo: configuracionAntifraude?.motivoExclusion,
    },
  })

  const handleCloseModal = () => {
    usuarioInvalidation()
    setShowModal(false)
    reset({
      verifactu:
        configuracionAntifraude?.estado.id ===
        ESTADO_CONFIGURACION_ANTIFRAUDE.VERIFACTU,
      exento:
        configuracionAntifraude?.estado.id ===
        ESTADO_CONFIGURACION_ANTIFRAUDE.EXENTO,
      motivo:
        configuracionAntifraude?.estado.id ===
        ESTADO_CONFIGURACION_ANTIFRAUDE.EXENTO
          ? configuracionAntifraude?.motivoExclusion
          : null,
    })
  }

  const toggleOpenModal = () => {
    setShowModal(!showModal)
  }

  const currentDate = configuracionAntifraude?.verifactu?.fechaInicioVerifactu
    ? new Date(configuracionAntifraude?.verifactu?.fechaInicioVerifactu)
    : new Date()
  const currentDateEnd = configuracionAntifraude?.verifactu?.fechaFinVerifactu
    ? new Date(configuracionAntifraude?.verifactu?.fechaFinVerifactu)
    : new Date()

  return (
    <div className='tw-flex tw-flex-col tw-text-left tw-mt-5'>
      <h2 className='tw-text-lg tw-font-medium tw-text-primary tw-mb-3'>
        {t("verifactu.configCard.title")}
      </h2>

      <VerifactuPending
        toggleOpenModal={toggleOpenModal}
        showCard={Boolean(!configuracionAntifraude?.estado.id)}
      />

      <VerifactuActive
        toggleOpenModal={toggleOpenModal}
        showCard={Boolean(
          configuracionAntifraude?.estado.id ===
            ESTADO_CONFIGURACION_ANTIFRAUDE.VERIFACTU
        )}
        fechaInicioVerifactu={currentDate}
        fechaFinVerifactu={currentDateEnd}
        estadoDescripcion={configuracionAntifraude?.estado.description ?? ""}
        estadoRevisionDocumentacion={
          configuracionAntifraude?.verifactu?.revisionDocumentacion
            ?.estadoRevisionDocumentacion
        }
        motivoRechazo={
          configuracionAntifraude?.verifactu?.revisionDocumentacion?.motivo ??
          undefined
        }
      />

      <VerifactuExento
        showCard={Boolean(
          configuracionAntifraude?.estado.id ===
            ESTADO_CONFIGURACION_ANTIFRAUDE.EXENTO
        )}
        toggleOpenModal={toggleOpenModal}
        estadoDescripcion={configuracionAntifraude?.estado.description ?? ""}
        motivoExclusion={configuracionAntifraude?.motivoExclusion ?? undefined}
      />

      <div className='isolated-wrapper'>
        <LeyAntiFraudeFormModal
          nif={empresaActiva?.nif ?? ""}
          razonSocial={empresaActiva?.razonSocial ?? ""}
          isOpen={showModal}
          handleCloseModal={handleCloseModal}
          estado={configuracionAntifraude?.estado.id}
          motivo={configuracionAntifraude?.motivoExclusion}
        />
      </div>
    </div>
  )
}
